import { DetailResponse } from 'repositories/invitation/responseType';
import { Invitation } from 'models/Invitation/type';

export const convertToInvitation = (response: DetailResponse): Invitation => {
  const invitationFor =
    response.results.invitation_for.type === 'Application'
      ? {
          name: response.results.invitation_for.name,
          iconUrl: response.results.invitation_for.icon_url,
        }
      : {
          name: response.results.invitation_for.name,
        };

  return {
    token: response.results.token,
    email: response.results.email,
    invitationFor,
    creatorName: response.results.creator.name,
  };
};
